import { Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { NotificationService } from './notification.service';

@Component({
  selector: 'app-notification-host',
  standalone: true,
  imports: [NgClass, TranslatePipe],
  templateUrl: './notification-host.component.html',
  styleUrl: './notification-host.component.scss'
})
export class NotificationHostComponent {
  protected readonly notificationService = inject(NotificationService);

  protected dismiss(id: number) {
    this.notificationService.dismiss(id);
  }
}
